module.exports = __webpack_public_path__ + "img/ReadyStatus.8a9942b9.svg";